import { useMergeRequestPanelState } from "./useMergeRequestPanelState";

/**
 * Keeps the merge request of the current branch in the store while a catalog is open, the read-only mode too. The
 * panel mounts only in editor mode, so an approver whose role covers just the merge request branch — read-only on the
 * main one, editor mode once they follow the merge request link — would get the panel after the branch update had
 * already passed, and no Merge Request button until a reload.
 */
export const MergeRequestStateSync = () => {
	useMergeRequestPanelState();
	return null;
};
